<ui-modal modalTitle="Edit Selected Task" size="xl" [showBackButton]="canGoBack()" (back)="goToPreviousStep()">

	<div class="d-flex align-items-center mb-2 justify-content-end" *ngIf="tabs && tabs.length">
		<ng-container *ngFor="let t of tabs; let last = last; let index = index">
			<button class="btn border-0 mr-2" [ngClass]="{ 'btn-outline-secondary': tab !== t && !t.done, 'btn-outline-success': tab !== t && t.done, 'btn-secondary': tab === t && !t.done, 'btn-success': tab === t && t.done }" (click)="selectTab(t)" [disabled]="disabled">{{index + 1}}. {{t.description}}</button>
			<i *ngIf="!last" class="wq wq-angle-right text-secondary mr-2"></i>
		</ng-container>
	</div>

	<ng-container *ngIf="step === 'operation'">
		<div class="d-flex justify-content-center">
			<div class="flex-weight-1 mr-4">
				<h3 class="mb-3 text-center">Sales Order</h3>
				<button (click)="setOperation('existing_sales_order')" class="btn btn-outline-secondary d-block w-100 my-2"><i class="wq wq-handshake mr-2"></i>Add to Existing Sales Order</button>
				<button (click)="setOperation('new_sales_order')" class="btn btn-outline-secondary d-block w-100 my-2"><i class="wq wq-add mr-2"></i>New Sales Order</button>
			</div>
			<div class="flex-weight-1 mr-4">
				<h3 class="mb-3 text-center">Quote</h3>
				<button (click)="setOperation('existing_quote')" class="btn btn-outline-secondary d-block w-100 my-2"><i class="wq wq-handshake mr-2"></i>Add to Quote</button>
			</div>
		</div>
	</ng-container>

	<div *ngIf="tabs.length" class="alert alert-info pb-0">
		<ng-container *ngIf="tab.id === 'select_so'">
			<h3>Add Tasks to Existing Sales Order</h3>
			<p>Select a sales order to assign the selected tasks to it.</p>
		</ng-container>

		<ng-container *ngIf="tab.id === 'select_quote'">
			<h3>Add Tasks to Existing Quote</h3>
			<p>Select a quote to assign the selected tasks to it.</p>
		</ng-container>

		<ng-container *ngIf="tab.id === 'map_labour_types'">
			<h3>Map the Engineers to the Labour Type</h3>
			<p>You need to assign a labour type to each engineer. These can be edited later.</p>
		</ng-container>
	</div>

	<ng-container *ngIf="step === 'select_sales_order' || step === 'select_quote'">
		<div class="scrollable" style="height: 500px;">
			<table *ngIf="list" class="table table-hover vam">
				<thead>
					<tr>
						<th>#</th>
						<th>Customer</th>
						<th class="nowrap">Assigned to</th>
						<th>Created</th>
						<th>Last Modified</th>
						<th>Location</th>
						<th class="shrink text-center">Status</th>
						<th class="nowrap text-right">Net total</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of list | pagination:pagination" class="selectable" [ngClass]="{ 'table-success': isItemSelected(item) }" (click)="selectItem(item)">
						<td class="text-secondary">{{item.quote_no}}</td>
						<td>
							<div>
								<b>{{item.customer_name}}</b>
								<ng-container *ngIf="item.project_description">
									<span class="text-secondary">/</span>
									<b class="text-info"> {{item.project_description}}</b>
								</ng-container>
							</div>
							<div class="text-secondary"><span *ngIf="item.is_sample" class="badge badge-warning">Sample</span> {{item.description}} <span *ngIf="item.revision > 1 || item.change_order" class="badge badge-secondary">R{{item.revision}}{{item.change_order ? '.' + item.change_order : ''}}</span></div>
						</td>
						<td><i class="wq mr-2" [ngClass]="{ 'wq-lock-open text-silver': item.is_public, 'wq-lock-closed text-secondary': !item.is_public }" ngbTooltip="Quote is {{item.is_public ? 'public' : 'private'}}"></i>{{item.user_name}}</td>
						<td>{{item.created_datetime | mySQLDateToISO | localizedDate:'shortDate'}}</td>
						<td>
							{{item.modified_datetime | mySQLDateToISO | localizedDate:'shortDate'}}<br>
							<small class="text-secondary">{{item.modified_text}}</small>
						</td>
						<td>{{item.posttown}}</td>
						<td class="shrink nowrap text-center pb-0">
							<div class="badge badge-{{stageColor(item.stage)}} d-block" [ngbTooltip]="item.stage === 'sent' ? formattedSQLDate(item.quote_date) : null">{{stageDescription(item.stage)}}</div>
							<div *ngIf="item.stage === 'sent' && item.expiry_date" class="text-small text-purple text-bold mt-1">Exp: {{item.expiry_date | mySQLDateToISO | localizedDate:'shortDate'}}</div>
							<div *ngIf="item.stage === 'accepted'" class="text-small text-success text-bold mt-1">{{item.accepted_date | mySQLDateToISO | localizedDate:'shortDate'}}</div>
						</td>
						<td class="text-right">
							<i *ngIf="item.has_cost_warning" class="wq wq-warning text-danger mr-1" ngbTooltip="Cost issues"></i>
							<i *ngIf="item.has_price_change" class="wq wq-warning text-warning mr-1" ngbTooltip="Price updates"></i>
							<ng-container *ngIf="item.grand_total !== null">
								{{item.grand_total | currency:item.currency_id}}
							</ng-container>
						</td>
					</tr>
					<tr *ngIf="!pagination.count">
						<td colspan="8" class="text-secondary">No {{type === 'sales_order' ? 'sales orders' : 'quotes'}} found.</td>
					</tr>
				</tbody>
			</table>

			<div *ngIf="!list" class="w-100 h-100 d-flex align-items-center justify-content-center">
				<div class="spinner-border text-secondary"></div>
			</div>
		</div>
		<app-pagination [ngClass]="{ 'invisible': !list }" [pagination]="pagination"></app-pagination>
	</ng-container>

	<ng-container *ngIf="step === 'map_labour_types'">
		<div class="scrollable" style="height: 500px;">
			<table *ngIf="data && data.pick_labour_categories.length && users.length; else noDataTemplate" class="table table-hover vam">
				<thead>
					<tr>
						<th>Engineer</th>
						<th class="shrink nowrap">Hours Worked</th>
						<th colspan="3">Labour Type</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of users">
						<td class="text-bold">
							<ui-user-image class="mr-1" [email]="item.email_addr" [title]="item.name"></ui-user-image>
							<span class="text-bold">{{item.name}}</span>
						</td>
						<td class="shrink nowrap">
							{{item.hours | hours}}
						</td>
						<td colspan="3">
							<div class="d-flex">
								<select class="custom-select" style="width: auto;" [(ngModel)]="user_labour_mapping[item.user_id].labour_type" (ngModelChange)="validateTabs()" [ngModelOptions]="{ standalone: true }">
									<option [ngValue]="null">None</option>
									<optgroup *ngFor="let category of data.pick_labour_categories" label="{{category.description}}">
										<option *ngFor="let type of category.types" [ngValue]="type.id">{{type.description}}</option>
									</optgroup>
								</select>
								<div *ngIf="app.orgInfo?.role.manage_configurations" class="dropdown dropdown-light d-inline-block ml-1">
									<button type="button" class="btn btn-outline-success p-2 dropdown-toggle" data-toggle="dropdown"><i class="wq wq-add"></i></button>
									<div class="dropdown-menu">
										<button type="button" class="dropdown-item dropdown-item-success" (click)="addNewLabourType(item)">Add New Labour Type</button>
										<a [href]="'/' + app.org + '/settings/configure/labour'" target="_blank" class="dropdown-item dropdown-item-success">Go to Labour Settings<i class="wq wq-open-new ml-2"></i></a>
									</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<ng-template #noDataTemplate>
				<div class="text-center mt-4">
					<p>No time entries found on the task.</p>
				</div>
			</ng-template>
		</div>
	</ng-container>

	<button type="button" class="btn btn-medium" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
	<div class="flex-weight-1" ui-modal-footer></div>
	<button *ngIf="step === 'map_labour_types'" type="submit" class="btn btn-primary" [disabled]="disabled || !tabLabourMapping.done" (click)="submitButton()" ui-modal-footer>Confirm</button>

</ui-modal>

<modal-edit-labour (close)="editLabourModalClosed($event)"></modal-edit-labour>
